module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="paylateInformer__container">\r\n	' + require("../parts/title.html").apply(null,arguments) + '\r\n	<div class="paylateInformer__text">\r\n		Все варианты оплаты доступны на странице заполнения паспортных данных после выбора тура.\r\n	</div>\r\n	' + require("../parts/infoBlock.html").apply(null,arguments) + '\r\n	<a href="/tury-v-rassrochku" target="_blank" class="paylateInformer__link">Подробнее <i class="icon-i16_arrow_right"></i></a>\r\n	';
 if (appConfig.isPaylateShare) { 
__p+='\r\n		<div class="paylateInformer__extra"> Акция продлится до 5 марта 2023 включительно.</div>\r\n	';
 } 
__p+='\r\n</div>';
}
return __p;
};
